import apiAnalytic from '@/api/analytic'

const state = {
  data: [],
  total: null,
  isLoading: false,
  error: null,
}

export const mutationTypes = {
  getAnalyticsStart: '[analytics] Get analytics start',
  getAnalyticsSuccess: '[analytics] Get analytics success',
  getAnalyticsFailure: '[analytics] Get analytics failure',

  getAnalyticsByParamsStart: '[analytics] Get analytics by params start',
  getAnalyticsByParamsSuccess: '[analytics] Get analytics by params success',
  getAnalyticsByParamsFailure: '[analytics] Get analytics by params failure',
}

export const actionTypes = {
  getAnalytics: '[analytics] Get analytics',
  getAnalyticsByParams: '[analytics] Get analytics by params',
}

const mutations = {
  [mutationTypes.getAnalyticsStart](state) {
    state.isLoading = true
    state.data = []
  },

  [mutationTypes.getAnalyticsSuccess](state, payload) {
    state.data = payload
    state.isLoading = false
  },

  [mutationTypes.getAnalyticsFailure](state) {
    state.isLoading = false
  },

  [mutationTypes.getAnalyticsByParamsStart](state) {
    state.isLoading = true
    state.data = []
  },

  [mutationTypes.getAnalyticsByParamsSuccess](state, payload) {
    state.data = payload.list
    state.total = payload.total || 0
    state.isLoading = false
  },

  [mutationTypes.getAnalyticsByParamsFailure](state) {
    state.isLoading = false
  },
}

const actions = {
  [actionTypes.getAnalytics](context) {
    context.commit(mutationTypes.getAnalyticsStart)
    return new Promise((resolve) => {
      apiAnalytic
        .getAnalytics()
        .then((response) => {
          context.commit(mutationTypes.getAnalyticsSuccess, response.data)
          resolve(response.data)
        })
        .catch(() => {
          context.commit(mutationTypes.getAnalyticsFailure)
        })
    })
  },

  [actionTypes.getAnalyticsByParams](context, {params}) {
    context.commit(mutationTypes.getAnalyticsByParamsStart)
    return new Promise((resolve) => {
      apiAnalytic
        .getAnalyticsByParams(params)
        .then((response) => {
          context.commit(mutationTypes.getAnalyticsByParamsSuccess, response)
          resolve(response)
        })
        .catch(() => {
          context.commit(mutationTypes.getAnalyticsByParamsFailure)
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
